import {Delete} from '@mui/icons-material';
import {useCan} from 'src/permissions/hooks';
import {IconButton} from '@mui/material';
import {FC, useState} from 'react';
import {useIntl} from 'react-intl';
import {chargersApi} from 'src/api';
import {useAppDispatch, useAppSelector} from 'src/app/hooks';
import AMPModal from 'src/components/common/AMPModal';
import {ConformationModal} from 'src/components/common/ConformationModal';
import {preloaderChangeStatus} from 'src/stores/common/commonSlice';
import {AppDispatch} from 'src/types';
import {NotifyError} from 'src/utils/notification';
import {DeleteScheduleType} from './DeleteSchedule.type';

type DeleteScheduleMutationTrigger = ReturnType<typeof chargersApi.useDeleteScheduleMutation>[0];

const handleDeleteSchedule =
    (
        trigger: DeleteScheduleMutationTrigger,
        dispatch: AppDispatch,
        scheduleChargingId: number,
        chargerId: number,
        businessId: number,
        userId: number,
        companyId: number | undefined,
        handleClose: () => void
    ) =>
        async () => {
            dispatch(preloaderChangeStatus(true));
            try {
                await trigger({scheduleChargingId, chargerId, businessId, userId, companyId}).unwrap();
                handleClose();
            } catch (error: any) {
                NotifyError(error.data.message);
            } finally {
                dispatch(preloaderChangeStatus(false));
            }
        };

export const DeleteSchedule: FC<DeleteScheduleType> = ({
                                                           chargerId,
                                                           scheduleChargingId,
                                                           businessId,
                                                       }) => {
    // The control is the action: without the permission the server refuses it, so showing it
    // offers a button whose only outcome is an error.
    const canDoIt = useCan('scheduleCharging.delete');
    const [trigger] = chargersApi.useDeleteScheduleMutation();
    const dispatch = useAppDispatch();
    const {authInfo} = useAppSelector((state) => state.common);

    const companyId = authInfo?.company?.id || authInfo?.employee?.company?.id;

    const intl = useIntl();
    const [open, setOpen] = useState<boolean>(false);
    const dialogTitle = intl.formatMessage({id: 'deleteSchedule'});

    const handleOpenModal = () => {
        setOpen(true);
    };

    const handleCloseModal = () => {
        setOpen(false);
    };
    if (!canDoIt) {
        return null;
    }

    return (
        <>
            <IconButton onClick={handleOpenModal}>
                <Delete/>
            </IconButton>
            <AMPModal
                handleClose={handleCloseModal}
                open={open}
                title={dialogTitle}
                type="md"
                fullWidth
                withoutPaddings
            >
                <ConformationModal
                    handleClose={handleCloseModal}
                    handleSubmit={handleDeleteSchedule(
                        trigger,
                        dispatch,
                        scheduleChargingId,
                        chargerId,
                        businessId,
                        authInfo.id,
                        companyId,
                        handleCloseModal
                    )}
                    text={'deleteScheduleDescription'}
                />
            </AMPModal>
        </>
    );
};
